/* eslint-disable react/no-array-index-key */
import { useEffect, useRef, useState } from 'react';
import Image from 'global/Image';
import VisibilitySensor from 'react-visibility-sensor';
import useDebounce from 'hooks/useDebounce';
import Masonry from 'react-masonry-css';
import {
  SearchInput,
  GifPickerWrapper,
  MasonryWrapper,
  GifWrapper,
} from './styled';
import gifPickerStore from './store';

interface GifPickerProps {
  onSelectGif: (data: any) => void;
  gifColumns?: number;
}

function GifPicker({ onSelectGif, gifColumns = 3 }: GifPickerProps) {
  const fetchGif = gifPickerStore((store) => store.fetchGif);
  const gifData = gifPickerStore((store) => store.data);
  const isLoading = gifPickerStore((store) => store.isLoading);
  const totalCount = gifPickerStore((store) => store.totalCount);

  const [keyword, setKeyword] = useState('');
  const [offset, setOffset] = useState(0);

  const keywordDebounce = useDebounce(keyword, 500);

  const wrapperRef = useRef();

  const handleLoadMore = (visible) => {
    if (!isLoading && offset < totalCount && visible) {
      const newOffset = offset + 30;

      if (keyword.length === 0) {
        fetchGif({
          type: 'trending',
          keyword,
          offset,
        });
      } else {
        fetchGif({
          type: 'search',
          keyword,
          offset,
        });
      }

      setOffset(newOffset);
    }
  };

  const onChangeKeyword = (e) => {
    const { value } = e.target;
    setKeyword(value);
  };

  useEffect(() => {
    if (keyword.length > 0) {
      fetchGif({
        type: 'search',
        offset: 0,
        keyword,
      });
    } else {
      fetchGif({
        type: 'trending',
        offset: 0,
        keyword,
      });
    }
    setOffset(0);
  }, [keywordDebounce]);

  const handleSelectGif = (e, image) => {
    e.stopPropagation();
    const { fixed_width_small: previewGif, fixed_height: postGif } = image;
    const data = {
      post: postGif.url,
      preview: previewGif.url,
    };

    onSelectGif(data);
  };

  return (
    <div>
      <GifPickerWrapper ref={wrapperRef}>
        <SearchInput
          placeholder="Search GIFs..."
          height="35px"
          width="100%"
          // @ts-expect-error
          mb="4px"
          py="10px"
          px="15px"
          onChange={onChangeKeyword}
          onPressEnter={(e) => e.preventDefault()}
          key="search-input"
          allowClear
        />
        <MasonryWrapper id="masonry-wrapper" ref={wrapperRef}>
          <Masonry
            breakpointCols={gifColumns}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {gifData.map(({ id, images }) => {
              const { fixed_width_small: previewSmallGif } = images;
              return (
                <GifWrapper key={id} onClick={(e) => handleSelectGif(e, images)}>
                  <Image
                    src={previewSmallGif.url}
                    alt={id}
                    style={{ width: '100%' }}
                  />
                </GifWrapper>
              );
            })}
          </Masonry>
          {!isLoading && (
          <VisibilitySensor
            onChange={handleLoadMore}
            scrollCheck
            key="visibility-sensor"
          >
            <div>&nbsp;</div>
          </VisibilitySensor>
          )}
        </MasonryWrapper>
      </GifPickerWrapper>
      <Image
        alt="giphy-attributes"
        src="/images/giphyattr.png"
        style={{ height: '10px', margin: '8px 4px' }}
      />
    </div>
  );
}

export default GifPicker;
